module.exports = __webpack_public_path__ + "static/img/baerupon.6c379a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baerupon.png
// module id = PL+W
// module chunks = 1